import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { VIVRE_EN_VILLE_PATHS } from './VivreEnVilleConstants'
import Loading from 'egret/components/EgretLoadable/Loading'

const Map = EgretLoadable({
  loader: async () => await import('./Map')
})

const Rents = EgretLoadable({
  loader: async () => await import('./Rents')
})

const Rent = EgretLoadable({
  loader: async () => await import('./Rent')
})

const vivreEnVilleRoutes: RouteConfig[] = [
  {
    path: VIVRE_EN_VILLE_PATHS.MAP,
    component: Map,
    auth: authRoles.vivre_en_ville,
    isTranslatable: true,
    label: <Trans>VIVRE_EN_VILLE_MAP</Trans>
  },
  {
    path: VIVRE_EN_VILLE_PATHS.RENTS,
    component: Rents,
    auth: authRoles.vivre_en_ville,
    isTranslatable: true,
    label: <Trans>VIVRE_EN_VILLE_RENTS_TAB</Trans>
  },
  {
    path: `${VIVRE_EN_VILLE_PATHS.RENT}/:id`,
    component: Rent,
    auth: authRoles.vivre_en_ville,
    isTranslatable: true,
    label: <Trans>VIVRE_EN_VILLE_ROUTES_RENT_OVERVIEW_LABEL</Trans>
  }
]

export default vivreEnVilleRoutes
